import { api } from './client';
import type { CategoriesData } from '../types';

export const categoriesApi = {
  get: () => api.get<CategoriesData>('/categories'),
  update: (data: CategoriesData) => api.put<CategoriesData>('/categories', data),
};
